module.exports = __webpack_public_path__ + "img/16.73dd5e3b.png";